import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ActiveObjectivesPopoverPage } from './active-objectives-popover';

@NgModule({
  declarations: [
    ActiveObjectivesPopoverPage,
  ],
  imports: [
    RouterModule,
    CommonModule,
    IonicModule.forRoot(),
  ],
})
export class ActiveObjectivesPopoverPageModule {}
